<div class="aside-content" [style.width]="width"
     [@viewState]="{value: open, params: { width: width}}">
  <ng-content></ng-content>
</div>
